import axiosClient from '../axiosClient';
import { PaymentTypeEndpoints } from '../endpoints/paymentType';

export const PaymentTypeService = {
  async listPaymentTypes(): Promise<string[]> {
    const res = await axiosClient.get<string[]>(PaymentTypeEndpoints.LIST);
    return res.data;
  },
};
